import React, { Component } from 'react';
import MessengerCustomerChat from 'react-messenger-customer-chat';
import Header from '../components/Header/header';
import HeroSection from '../components/HeroSection/HeroSection1';
import PromoSection from '../components/PromoSection';
import AboutSection from '../components/AboutUs';
import FeatureSection from '../components/Features';
import Story from '../components/Story';
import DownloadSection from '../components/Download';
import PricingOutdoor from '../components/Pricing/PricingOutdoor';
import TeamMember from '../components/TeamMember';
import SubscribeSection from '../components/Subscribe';
import FooterSection from '../components/Footer';

class OutdoorActivities extends Component {
  render() {
    return (
      <>
        <MessengerCustomerChat
          pageId="101590111335192"
          appId="695593052231950" 
        />
        <Header />
        <div className="main">
          <PricingOutdoor hideFaq={true} />
        </div>
        <SubscribeSection />
        <FooterSection />
      </>
    );
  }
}

export default OutdoorActivities;
